module.exports = __webpack_public_path__ + "media/images/bu_02-8479b440613c5c542beb8886c7a12bc0.jpg";